var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "internal-message-detail-container" },
    [
      _c(_setup.CustomDialogHeaderComponent, {
        attrs: { headerTitle: _setup.TEXT.title },
      }),
      _c("div", { staticClass: "message-content" }, [
        _c("div", { staticClass: "field-row-with-date" }, [
          _c("div", { staticClass: "field-group" }, [
            _c("span", { staticClass: "field-label" }, [
              _vm._v(_vm._s(_setup.TEXT.from) + ":"),
            ]),
            _c("span", { staticClass: "field-value" }, [
              _vm._v(_vm._s(_setup.props.componentProps.message.de)),
            ]),
          ]),
          _c("span", { staticClass: "date-info" }, [
            _vm._v(_vm._s(_setup.formattedDate)),
          ]),
        ]),
        _c("div", { staticClass: "field-group" }, [
          _c("span", { staticClass: "field-label" }, [
            _vm._v(_vm._s(_setup.TEXT.to) + ":"),
          ]),
          _c("span", { staticClass: "field-value" }, [
            _vm._v(_vm._s(_setup.props.componentProps.message.para)),
          ]),
        ]),
        _c("div", { staticClass: "subject-section" }, [
          _c("h4", { staticClass: "subject-title" }, [
            _vm._v(_vm._s(_setup.props.componentProps.message.asunto)),
          ]),
          _c("p", { staticClass: "message-text" }, [
            _vm._v(_vm._s(_setup.props.componentProps.message.cuerpo || "")),
          ]),
        ]),
      ]),
      _c(_setup.CustomDialogActionButtonsComponent, {
        attrs: {
          showSecondaryButton: false,
          primaryButtonText: _setup.TEXT.accept,
          mainAction: _setup.handleAccept,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }